// WEB SOURCES in an AI answer (U4) — the `sources` card toolEmbedCard builds
// from a web tool's embed (functions/_simone/toolEmbed.js): search results as
// SOURCE CARDS (title, domain, snippet — each a real link to its page) and a
// fetched page as a QUOTE with its source. Drawn by AssistantThreadBlock
// (BlockSources) with AssistantSourceCard.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.

// The host a reader recognises: "colliers.com", never "www.colliers.com".
export const assistantSourceDomain = function assistantSourceDomain(url) {
  const m = /^https?:\/\/([^/?#:]+)/i.exec(String(url || ''))
  return m ? m[1].toLowerCase().replace(/^www\./, '') : ''
}

// The cards: [{ key, title, domain, snippet, url }]. A source without a title
// is named by its domain. A quoted page is not repeated as a card.
export const assistantSourcesRows = function assistantSourcesRows(s) {
  const x = s && typeof s === 'object' ? s : {}
  if (x.type !== 'sources' || !Array.isArray(x.sources)) return []
  if (x.text && x.sources.length === 1) return []
  return x.sources.map((src) => {
    const domain = this.call('assistantSourceDomain', src.url)
    return {
      key: src.url,
      title: src.title || domain,
      domain,
      snippet: src.snippet || '',
      url: src.url
    }
  })
}

// The quote: a fetched page's text with its one source; null otherwise.
export const assistantSourcesQuote = function assistantSourcesQuote(s) {
  const x = s && typeof s === 'object' ? s : {}
  if (x.type !== 'sources' || !x.text || !Array.isArray(x.sources) || x.sources.length !== 1) {
    return null
  }
  const src = x.sources[0]
  const domain = this.call('assistantSourceDomain', src.url)
  return { text: String(x.text), title: src.title || domain, domain, url: src.url }
}

// The card's title: "Web results: <query>", a page "From <domain>", else
// "Sources".
export const assistantSourcesTitle = function assistantSourcesTitle(s) {
  const x = s && typeof s === 'object' ? s : {}
  const quote = this.call('assistantSourcesQuote', x)
  if (quote) {
    return String(this.call('polyglot', 'workspace.assistantBlock.sourcesPage')).replace(
      '{domain}',
      quote.domain
    )
  }
  if (x.query) {
    return String(this.call('polyglot', 'workspace.assistantBlock.sourcesQuery')).replace(
      '{query}',
      x.query
    )
  }
  return String(this.call('polyglot', 'workspace.assistantBlock.sourcesTitle'))
}

// The foot: "From the web · 2 sources".
export const assistantSourcesFoot = function assistantSourcesFoot(s) {
  const x = s && typeof s === 'object' ? s : {}
  const n = Array.isArray(x.sources) ? x.sources.length : 0
  return String(
    this.call(
      'polyglot',
      n === 1 ? 'workspace.assistantBlock.sourcesFootOne' : 'workspace.assistantBlock.sourcesFoot'
    )
  ).replace('{count}', String(n))
}
